module.exports = __webpack_public_path__ + "static/img/dsk-fact.dc5908a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-fact.jpg
// module id = 229
// module chunks = 1